import { defineComponent as _defineComponent } from 'vue'
import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import { computed } from "vue";
  import store from "@/store";
  import { scrollToNextStepMobile } from "@/helpers/builder/scrollToNextStep";
  import { BuilderStepsIdsPagination } from "@/enums/BuilderStepsIds";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderButtonsPagination',
  props: {
    skipStep: String,
  },
  emits: ["toRequestQuoteForm", "toReturnMap"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const selectedQuote = computed(
    () => store.getters["builder/getSelectedSelection"]
  );

  const currentStepIndex = computed(() => {
    const currentStep = selectedQuote.value?.currentStep;

    return Object.values(CustomizeHouseStepsEnum).indexOf(currentStep);
  });

  const nextStepIndex = computed(() => {
    let currentStepIndexVal = currentStepIndex.value;

    if (currentStep.value === props?.skipStep) {
      currentStepIndexVal++;
    }

    return (
      (currentStepIndexVal + 1) % Object.values(CustomizeHouseStepsEnum).length
    );
  });

  const prevStepIndex = computed(() => {
    return (
      (currentStepIndex.value -
        1 +
        Object.values(CustomizeHouseStepsEnum).length) %
      Object.values(CustomizeHouseStepsEnum).length
    );
  });

  const currentStep = computed(() => {
    return Object.values(CustomizeHouseStepsEnum)[currentStepIndex.value];
  });

  const nextStepText = computed(() => {
    let nextStep = Object.values(CustomizeHouseStepsEnum)[nextStepIndex.value];

    if (nextStep === props.skipStep) {
      nextStep = Object.values(CustomizeHouseStepsEnum)[
        nextStepIndex.value + 1
      ];
    }

    return nextStep;
  });

  const prevStepText = computed(() => {
    let prevStep = Object.values(CustomizeHouseStepsEnum)[prevStepIndex.value];

    if (prevStep === props.skipStep) {
      return Object.values(CustomizeHouseStepsEnum)[prevStepIndex.value - 1];
    }

    return prevStep;
  });

  const nextStepId = computed(() => {
    return Object.values(BuilderStepsIdsPagination)[currentStepIndex.value];
  });

  const prevStepId = computed(() => {
    return Object.values(BuilderStepsIdsPagination)[currentStepIndex.value];
  });

  const isBuilderCompleted = computed(() => {
    const builder = selectedQuote.value.builder;

    return Object.values(builder).every((field) => field !== "");
  });

  const isHouseDesignCompleted = computed(() => {
    const house = selectedQuote.value.house;

    return Object.values(house).every((field) => field !== "");
  });

  const isFacadeCompleted = computed(() => {
    const facade = selectedQuote.value.facade;

    return Object.values(facade).every((field) => field !== "");
  });

  const isNextStepEnabled = computed(() => {
    switch (currentStep.value) {
      case CustomizeHouseStepsEnum.BUILDER:
        return isBuilderCompleted.value;
      case CustomizeHouseStepsEnum.HOUSE_DESIGN:
        return isHouseDesignCompleted.value;
      case CustomizeHouseStepsEnum.EXTERIOR:
        return isFacadeCompleted.value;
      default:
        return true;
    }
  });

  const nextStepTextButton = computed(() =>
    currentStep.value === CustomizeHouseStepsEnum.CONFIRMATION
      ? "Confirm"
      : "Next"
  );

  function onSelectNext() {
    if (currentStep.value === CustomizeHouseStepsEnum.CONFIRMATION) {
      emits("toRequestQuoteForm");
    } else {
      store.commit("builder/updateUserSelection", {
        ...selectedQuote.value,
        currentStep: nextStepText.value,
      });
      scrollToNextStepMobile(nextStepId.value);
    }
  }

  function onSelectPrev() {
    if (currentStep.value === CustomizeHouseStepsEnum.LOT) {
      emits("toReturnMap");
    } else {
      store.commit("builder/updateUserSelection", {
        ...selectedQuote.value,
        currentStep: prevStepText.value,
      });
    }
  }

const __returned__ = { emits, props, selectedQuote, currentStepIndex, nextStepIndex, prevStepIndex, currentStep, nextStepText, prevStepText, nextStepId, prevStepId, isBuilderCompleted, isHouseDesignCompleted, isFacadeCompleted, isNextStepEnabled, nextStepTextButton, onSelectNext, onSelectPrev, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, computed, get store() { return store }, get scrollToNextStepMobile() { return scrollToNextStepMobile }, get BuilderStepsIdsPagination() { return BuilderStepsIdsPagination } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})